/** Translate display controls into native writable columns; the service determines record authority. */
const columns = {
  name: 'name',
  primaryUseType: 'primary_use_type',
  focusedUseType: 'focused_use_type',
  constructionType: 'construction_types',
  dealStage: 'deal_stage',
  compType: 'comp_type',
  closeDate: 'dmre_close_date',
  pricedAcreage: 'priced_acreage',
  unitOrLotCount: 'unit_or_lot_count',
  purchasePrice: 'purchase_price',
  priceDisplay: 'price_display',
  pricingVerified: 'comp_pricing_verified',
};
export function nativeDealPatch(fields) {
  return Object.fromEntries(
    Object.entries(fields)
      .filter(([key]) => columns[key])
      .map(([key, value]) => [columns[key], value]),
  );
}
